exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: stretch;\n      -ms-flex-align: stretch;\n          align-items: stretch; }\n\n/* ---------------------------------------------------\n    CONTENT STYLE\n----------------------------------------------------- */\n.content {\n  padding: 20px;\n  min-height: 100vh;\n  transition: all 0.3s; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/layout/dashboard-layout/dashboard-layout.component.scss
// module id = ../../../../../src/app/layout/dashboard-layout/dashboard-layout.component.scss
// module chunks = main